import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initTraceContext } from './services/audit/traceContext';
// Self-hosted faces — latin + latin-ext only (ES/EN), no Google CDN.
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-ext-400.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-ext-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-ext-600.css';
import '@fontsource/manrope/latin-700.css';
import '@fontsource/manrope/latin-ext-700.css';
import '@fontsource/manrope/latin-800.css';
import '@fontsource/manrope/latin-ext-800.css';
import '@fontsource/source-serif-4/latin-400.css';
import '@fontsource/source-serif-4/latin-ext-400.css';
import '@fontsource/source-serif-4/latin-400-italic.css';
import '@fontsource/source-serif-4/latin-ext-400-italic.css';
import '@fontsource/source-serif-4/latin-600.css';
import '@fontsource/source-serif-4/latin-ext-600.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-ext-400.css';
import '@fontsource/jetbrains-mono/latin-500.css';
import '@fontsource/jetbrains-mono/latin-ext-500.css';
import '@fontsource/jetbrains-mono/latin-600.css';
import '@fontsource/jetbrains-mono/latin-ext-600.css';
import './styles/main.scss';

initTraceContext();

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// Firebase platform bootstrap after first paint (RC / App Check / Performance).
void import('./services/firebase/platform')
  .then(({ bootstrapFirebasePlatform }) => bootstrapFirebasePlatform())
  .catch((err) => {
    console.error('[Firebase] platform bootstrap failed:', err);
  });

// Shell asset cache (same SW as FCM) — independent of push permission.
void import('./services/shellServiceWorker').then(({ registerShellServiceWorker }) => {
  registerShellServiceWorker();
});
